import { Component, Input, OnInit } from '@angular/core';
import { Address } from '../../../models/entity/address';
import { AuthService } from '../../../services/auth.service';
import { StoreCacheService } from '../../../services/cache/store-cache.service';
import { StringUtils } from '../../../utils/string.utils';


@Component({
  selector: 'app-address-maps-widget',
  templateUrl: './address-maps-widget.component.html',
  styleUrls: ['./address-maps-widget.component.css']
})
export class AddressMapsWidgetComponent implements OnInit {
  @Input() address: Address;
  storeAddress: Address;
  constructor(private storeCacheService: StoreCacheService,
    private authService: AuthService) { }

  ngOnInit(): void {
  }

  getAddressForMaps() {
    let query = "https://www.google.com/maps/dir";

    let sourceKey = this.getSearchKey(this.storeAddress);
    let destinationKey = this.getSearchKey(this.address);

    if (!StringUtils.isEmpty(sourceKey))
      query = query + "/" + sourceKey;

    if (!StringUtils.isEmpty(destinationKey))
      query = query + "/" + destinationKey;

    return query;

  }

  getSearchKey(data: Address) {

    if (data.isLocationValid) {
      return data.latitude + "," + data.longitude;
    }

    let searchKey = "";

    if (!StringUtils.isEmpty(data.description))
      searchKey = searchKey + data.description + ",";

    if (!StringUtils.isEmpty(data.subProvinceName))
      searchKey = searchKey + data.subProvinceName + ",";

    if (!StringUtils.isEmpty(data.countryName))
      searchKey = searchKey + data.cityName + "," + data.countryName;

    return searchKey.split("/").join(" ");
  }


  openMaps() {
    if (this.storeAddress == null)
      this.getStoreAddress();
    else
      this.openUrlInBrowser();
  }

  private openUrlInBrowser() {
    window.open(this.getAddressForMaps(), '_blank');
  }

  private getStoreAddress() {
    this.storeCacheService.getAddressByStoreId(this.authService.getStoreId()).subscribe(data => {
      this.storeAddress = data;
      this.openUrlInBrowser();
    });
  }


}
